import { Helmet } from "react-helmet-async";

const SITE = "https://kyrolabs.ai";
const DEFAULT_OG = `${SITE}/og-image.png`;
const DEFAULT_TITLE = "KyroLabs, Agentic AI for Enterprise CX & Contact Centres";
const DEFAULT_DESC =
    "KyroLabs builds agentic AI for enterprise customer experience and contact centres, voice, chat and operations agents across travel, BFSI, consumer durables and BPO.";

/**
 * Per-page SEO tags.  Sets <title>, <meta description>, <link canonical>,
 * OG + Twitter cards, and optional JSON-LD schema.  Rendered via
 * react-helmet-async so it updates on every route change AND is picked up
 * by our post-build prerender step (see scripts/prerender.js).
 */
export default function SEO({
    title,
    description,
    path = "/",
    image = DEFAULT_OG,
    schema = null,
    noindex = false,
}) {
    const fullTitle = title
        ? (title.includes("KyroLabs") ? title : `${title} | KyroLabs`)
        : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    const url = `${SITE}${path === "/" ? "/" : path.replace(/\/$/, "")}`;
    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />
            <link rel="canonical" href={url} />
            {noindex && <meta name="robots" content="noindex,nofollow" />}

            {/* Open Graph */}
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="KyroLabs" />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={image} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={desc} />
            <meta name="twitter:image" content={image} />

            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}
        </Helmet>
    );
}
